<template>
    <div id="app">
        <router-view
            v-bind:selectEnvironments="selectEnvironments"
            v-bind:activeEnv="activeEnv"
            v-bind:envListImages="envListImages"
            v-on:addEnv="addEnv"
            v-on:removeEnv="removeEnv"
            v-on:setActiveEnv="setActiveEnv"
        />
    </div>
</template>


<script>
    // import json from './_results.json'


    export default {
        name: 'app',
        data() {
            return {
                selectEnvironments: [],
                activeEnv: false,
                headers: 'computacentar',
                // globalData: json,
                envListImages:false,
            }
        },
        mounted() {
            if (localStorage.selectEnvironments) {
                try {
                    this.selectEnvironments = JSON.parse(localStorage.getItem('selectEnvironments'));
                } catch (e) {
                    localStorage.removeItem('selectEnvironments');
                }
            }
            if (localStorage.activeEnv) {
                try {
                    this.activeEnv = JSON.parse(localStorage.getItem('activeEnv'));
                } catch (e) {
                    localStorage.removeItem('activeEnv');
                }
            }
            this.createImageEnvList()
        },
        // watch: {
        //     'activeEnv'() {
        //     },
        //     selectEnvironments(newData) {
        //
        //     }
        // },
        components: {},

        methods: {
            setActiveEnv(env_id) {
                let active_env = false;
                let elEnv = this.globalData.environments.filter((el) => {
                    return el.id == env_id;
                });

                if (elEnv[0].grouptype) {
                    let subEnv = this.globalData.environments.filter((el) => {
                        return el.parent == env_id;
                    });
                    active_env = subEnv[0].id
                } else {
                    active_env = env_id;
                }
                this.activeEnv = active_env;
                const parsed = JSON.stringify(this.activeEnv);
                localStorage.setItem('activeEnv', parsed);
            },

            addEnv(id) {
                if (this.selectEnvironments.indexOf(id) == -1) {
                    this.selectEnvironments.push(id);
                }
                this.saveSelectEnvironments();
            },
            removeEnv(id) {
                this.selectEnvironments = this.selectEnvironments.filter(function (item) {
                    return item !== id
                })
                this.saveSelectEnvironments();
            },
            saveSelectEnvironments() {
                const parsed = JSON.stringify(this.selectEnvironments);
                localStorage.setItem('selectEnvironments', parsed);
            },
            getCheldrens() {
                var elem = false;
                return elem;
            },
            getParent() {
                let parent = false;
                return false;
            },
            createImageEnvList() {
                // foce load images
                let navList = [];
                this.globalData.environments.forEach((item, i) => {
                    if (item.image) {
                        navList.push(item.image)
                    }
                    if (item.image_smart) {
                        navList.push(item.image_smart)
                    }
                    if (item.icon) {
                        navList.push(item.icon)
                    }
                });
                this.envListImages = navList;
            },
        }

    }
</script>
